import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../components/api.js";
import Header from "../components/Header.js";
import { Link } from "react-router-dom";
import { Spinner, Modal, Button } from "react-bootstrap";

const OrdersForms = () => {
  const [menuItems, setMenusItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [showModal, setShowModal] = useState(false); // État pour afficher ou masquer le modal
  const [selectedItem, setSelectedItem] = useState(null); // Plat sélectionné pour la commande
  const [quantity, setQuantity] = useState(1); // Quantité choisie
  const [notes, setNotes] = useState(""); // Remarques supplémentaires
  const [localisation, setLocalisation] = useState(""); // Adresse de livraison
  const [loader, setLoader] = useState(false); //Loader pour le button du modal

  const navigate = useNavigate();

  useEffect(() => {
    // On s'assure que le chargement commence
    setLoading(true);

    api
      .get("/menu")
      .then((response) => {
        setMenusItems(response.data);
      })
      .catch((err) => {
        setErr("Erreur lors de la récupération des données");
        console.log(err);
      })
      .finally(() => {
        // ✅ C'est ICI qu'on l'arrête, peu importe si ça a réussi ou échoué
        setLoading(false);
      });
  }, []);

  const handleShowModal = (item) => {
    setSelectedItem(item); // Définir l'item sélectionné
    setShowModal(true); // Afficher le modal
  };

  const handleCloseModal = () => {
    setShowModal(false); // Fermer le modal
    setQuantity(1); // Réinitialiser la quantité
    setNotes(""); // Réinitialiser les notes
  };

  const handleSubmitOrder = (e) => {
    e.preventDefault();

    if (!quantity || !localisation) {
      alert("Veuillez remplir tous les champs");
      return;
    }

    const orderData = {
      menu_item_id: selectedItem.id,
      name: selectedItem.name,
      quantity: quantity,
      price: selectedItem.price * quantity,
      notes: notes,
      localisation: localisation,
    };

    setLoader(true);

    api
      .post("/place_order", orderData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setLoader(false);
        console.log(response.data);
        alert("Commande confirmée");
        navigate("/historical"); // Rediriger vers l'historique des commandes après confirmation
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
        alert("Erreur de l'enregistrement de la commande");
      });

    // Ici, on peut envoyer la commande à l'API ou afficher un message
    console.log("Commande confirmée:", { selectedItem, quantity, notes });
    // setShowModal(false);  // Fermer le modal après soumission
  };

  return (
    <>
      <Header />
      <div className="container py-5">
        <div className="d-block d-md-none text-start mb-4">
          <Link
            to="/dashboard"
            className="text-decoration-none fw-bold text-orange"
          >
            <strong>← Tableau de bord</strong>
          </Link>
        </div>
        <div className="text-center mb-5">
          <h1 className="fw-bold display-5">Nos Menus du Jour</h1>
          <p className="text-muted">
            Sélectionnez votre plat et faites-vous livrer en salle.
          </p>
          <div
            className="mx-auto bg-warning"
            style={{ height: "3px", width: "50px" }}
          ></div>
        </div>

        <div className="row g-4">
          {loading ? (
            <div className="text-center mt-5">
              <Spinner animation="grow" variant="primary" />
              <p className="mt-3 text-muted">
                Chargement des menus disponibles...
              </p>
            </div>
          ) : menuItems.length > 0 ? (
            menuItems
              .filter((item) => item.available === 1)
              .map((item) => (
                <div className="col-12 col-md-6 col-lg-4" key={item.id}>
                  <div className="card h-100 shadow-sm border-0 transition-hover">
                    <div className="position-relative">
                      <img
                        src={item.image_path || "/images/COMMANDO.png"}
                        alt={item.name}
                        className="card-img-top"
                        style={{ height: "200px", objectFit: "cover" }}
                      />
                      <span className="position-absolute top-0 end-0 m-3 badge rounded-pill bg-dark opacity-75 py-2 px-3">
                        {item.price} FCFA
                      </span>
                    </div>

                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title fw-bold">{item.name}</h5>
                      <p className="card-text text-muted small flex-grow-1">
                        {item.description}
                      </p>

                      <div className="d-flex align-items-center justify-content-between mt-3">
                        <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-2">
                          Disponible
                        </span>
                        <Button
                          variant="primary"
                          className="rounded-pill px-4 shadow-sm"
                          onClick={() => handleShowModal(item)}
                          style={{ backgroundColor: "#f5721e", border: "none" }}
                        >
                          Commander
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
          ) : (
            <div className="col-12 text-center py-5">
              <div className="alert alert-info border-0 shadow-sm">
                Aucun menu n'est disponible pour le moment.
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modal de commande optimisé */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="md">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold">Finaliser la commande</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-2">
          <div className="d-flex align-items-center mb-4 p-3 bg-light rounded">
            <img
              src={selectedItem?.image_path}
              className="rounded me-3"
              style={{ width: "60px", height: "60px", objectFit: "cover" }}
            />
            <div>
              <h6 className="mb-0 fw-bold">{selectedItem?.name}</h6>
              <small className="text-orange fw-bold">
                {selectedItem?.price} FCFA / unité
              </small>
            </div>
          </div>

          <form onSubmit={handleSubmitOrder}>
            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="form-label fw-semibold small text-uppercase">
                  Quantité
                </label>
                <input
                  type="number"
                  className="form-control form-control-lg border-2"
                  id="quantity"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  min="1"
                />
              </div>
              <div className="col-md-8 mb-3">
                <label className="form-label fw-semibold small text-uppercase">
                  Localisation (Salle/Étage)
                </label>
                <input
                  type="text"
                  className="form-control form-control-lg border-2"
                  id="localisation"
                  value={localisation}
                  onChange={(e) => setLocalisation(e.target.value)}
                  placeholder="Ex: Salle 302, 6ème étage"
                  required
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold small text-uppercase">
                Remarques
              </label>
              <textarea
                className="form-control border-2"
                id="notes"
                rows="2"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Ex: Sans oignons, sauce à part..."
              ></textarea>
            </div>

            <Button
              variant="primary"
              type="submit"
              className="w-100 py-3 fw-bold rounded-pill shadow"
              disabled={loader}
              style={{ backgroundColor: "#f5721e", border: "none" }}
            >
              {loader ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Envoi...
                </>
              ) : (
                `Confirmer la commande (${(quantity * (selectedItem?.price || 0)).toFixed(2)} FCFA)`
              )}
            </Button>
          </form>
        </Modal.Body>
      </Modal>

      <style>{`
    .text-orange { color: #f5721e; }
    .transition-hover { transition: transform 0.2s ease-in-out; }
    .transition-hover:hover { transform: translateY(-5px); }
  `}</style>
    </>
  );
};

export default OrdersForms;
